import { Type, type Static } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
import Color from 'colorjs.io';

export const ThemeJsonSchema = Type.Object({
  primary: Type.String(),
  variant: Type.Union([
    Type.Literal('professional'),
    Type.Literal('tint'),
    Type.Literal('vibrant'),
  ]),
  appearance: Type.Union([
    Type.Literal('light'),
    Type.Literal('dark'),
    Type.Literal('system'),
  ]),
  radius: Type.Number(),
});

export type Theme = Static<typeof ThemeJsonSchema>;

export const safeParseThemeJson = (content: string): Theme | null => {
  try {
    const parsed = JSON.parse(content);
    const result = Value.Parse(ThemeJsonSchema, parsed);

    // throws if invalid
    new Color(result.primary);

    return result;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);

    return null;
  }
};

/**
 * these are the variables that @shadcn/ui uses.
 * `createTheme` needs to return an object like this.
 * the values are the inner values you'd pass to `hsl()`.
 */
export type CssVars = {
  '--background': string;
  '--foreground': string;
  '--muted': string;
  '--muted-foreground': string;
  '--popover': string;
  '--popover-foreground': string;
  '--card': string;
  '--card-foreground': string;
  '--border': string;
  '--input': string;
  '--primary': string;
  '--primary-foreground': string;
  '--secondary': string;
  '--secondary-foreground': string;
  '--accent': string;
  '--accent-foreground': string;
  '--destructive': string;
  '--destructive-foreground': string;
  '--ring': string;
  '--radius': string;
};
